<script>
import { Doughnut } from "vue-chartjs";
import ChartJSPluginDoughnutLabel from "chartjs-plugin-doughnutlabel";

export default {
  extends: Doughnut,
  // mixins: [mixins.reactiveProp],
  props: {
    nums: {
      type: [Object, Array],
      default: () => {
        return {
          data: [1, 1, 1],
          colors: ["#0091ff", "#f4b21b", "#66bdff"]
        };
      }
    },
    abbr: {
      type: String,
      default: "XX"
    },
    dark: {
      type: Boolean,
      default: false
    },
    which: {
      type: Number,
      default: 1
    }
  },
  data: function() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        events: [],
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
          }
        },
        elements: {
          arc: {
            //   backgroundColor: () => {
            //     if (this.which === 2) {
            //       return ["#0091ff", "#66bdff", "#f86726", "#f2d864", "#f4b21b", "#f1f1f2"];
            //     }
            //     if (this.dark) {
            //       return ["#0091ff", "#66bdff", "#f1f1f2"];
            //     } else {
            //       if (this.abbr === "JP") {
            //         return ["#66bdff", "#0091ff", "#f1f1f2"];
            //       }
            //       return ["#0091ff", "#66bdff", "#f1f1f2"];
            //     }
            //   },
            borderWidth: 0
          }
        },
        cutoutPercentage: 67,
        plugins: {
          doughnutlabel: {
            labels: [
              {
                text: this.abbr,
                // text: "test",
                font: {
                  size: "18",
                  weight: 700
                },
                color: () => {
                  if (this.dark) {
                    return "#FFFFFF";
                  } else {
                    return "#000000";
                  }
                }
              }
            ]
          }
        }
      }
    };
  },
  computed: {
    chartableCountry() {
      return {
        datasets: [
          {
            data: this.nums.data,
            backgroundColor: this.nums.colors
          }
        ]
      };
    }
  },
  mounted() {
    this.addPlugin(ChartJSPluginDoughnutLabel);
    this.renderChart(this.chartableCountry, this.options);
  }
};
</script>
